import { CopyToClipboard } from 'components/CopyToClipboard/CopyToClipboard';
import { Dialog } from 'components/Dialog/Dialog';
import { TextInput } from 'components/TextInput/TextInput';
import type { FC, FocusEvent } from 'react';

interface Props {
  text: string | null;
  onClose: () => void;
  msg: {
    title: string;
    button?: string;
    warning?: string;
  };
}

export const CopyTextDialog: FC<Props> = (props) => {
  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    e.target.select();
  };

  if (!props.text) {
    return null;
  }

  return (
    <Dialog
      headerMsg={props.msg.title}
      primaryBtnMsg={props.msg.button ?? 'OK'}
      onPrimaryClick={props.onClose}
      onClose={props.onClose}
    >
      <div className='relative'>
        <TextInput
          onFocus={handleFocus}
          readOnly
          suffixText={<CopyToClipboard text={props.text} />}
          type='text'
          value={props.text}
        />
        {props.msg.warning && (
          <p className='text-red-600'>{props.msg.warning}</p>
        )}
      </div>
    </Dialog>
  );
};
